function AboutTwo({ item }) {
    return (
        <div className='px-4 flex flex-col gap-1 font-medium'>
            <h1 className='text-[20px] leading-7 text-[#FFFFFF]'>{item.item.Heading}</h1>

            <p className='text-[14px] leading-[26px] text-[#B0B0B0]'>{item.item.Description}</p>
        </div>
    );
}

export default AboutTwo;
